"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssetDocumentFileFormatFromUrl = getAssetDocumentFileFormatFromUrl;
exports.getAssetTypeFromFile = getAssetTypeFromFile;
exports.isAssetFileTypeValid = isAssetFileTypeValid;
exports.isAssetFileSizeValid = isAssetFileSizeValid;
exports.getAssetsSorterFunc = getAssetsSorterFunc;
// @ts-ignore
const mime_1 = require("mime");
const asset_1 = require("@src/types/asset");
const allowed_upload_mime_types_1 = require("@src/shared/allowed-upload-mime-types");
function isUploadingAsset(asset) {
    return asset.progressPercentage !== undefined;
}
function getAssetDocumentFileFormatFromUrl(url) {
    const extension = url.split('.').pop();
    if (!extension) {
        return asset_1.AssetDocumentFileFormat.OTHER;
    }
    if (extension === 'pdf') {
        return asset_1.AssetDocumentFileFormat.PDF;
    }
    // https://docs.microsoft.com/en-us/deployoffice/compat/office-file-format-reference
    if (['doc', 'docx', 'docm', 'dotm', 'dotx', 'dot'].includes(extension)) {
        return asset_1.AssetDocumentFileFormat.WORD;
    }
    // https://support.microsoft.com/en-us/office/file-formats-that-are-supported-in-excel-0943ff2c-6014-4e8d-aaea-b83d51d46247
    if (['xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt'].includes(extension)) {
        return asset_1.AssetDocumentFileFormat.EXCEL;
    }
    return asset_1.AssetDocumentFileFormat.OTHER;
}
function getAssetTypeFromFile(file) {
    if (file.type.split('/')[0] === 'image') {
        return asset_1.AssetType.IMAGE;
    }
    if (file.type.split('/')[0] === 'video') {
        return asset_1.AssetType.VIDEO;
    }
    return asset_1.AssetType.DOCUMENT;
}
function isAssetFileTypeValid(file) {
    // file.type is not always set or correct
    const fileMimeType = (0, mime_1.getType)(file.name);
    return allowed_upload_mime_types_1.ALLOWED_UPLOAD_MIME_TYPES.includes(fileMimeType);
}
function isAssetFileSizeValid(file, maxFileSizeInMb) {
    const fileSizeInMb = file.size / 1024 / 1024;
    return fileSizeInMb < maxFileSizeInMb;
}
function getAssetsSorterFunc(moveDocumentsToBottom) {
    return (fst, snd) => {
        if (isUploadingAsset(fst) && isUploadingAsset(snd)) {
            return snd.uploadStartedAt.getTime() - fst.uploadStartedAt.getTime();
        }
        if (!isUploadingAsset(fst) && !isUploadingAsset(snd)) {
            if (!moveDocumentsToBottom || fst.type === snd.type) {
                return snd.createdAt.getTime() - fst.createdAt.getTime();
            }
            if (fst.type === asset_1.AssetType.DOCUMENT) {
                return 1;
            }
            if (snd.type === asset_1.AssetType.DOCUMENT) {
                return -1;
            }
            return snd.createdAt.getTime() - fst.createdAt.getTime();
        }
        throw new Error('Cannot sort Assets with Uploading assets');
    };
}
